import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { ButtonTradingStyled } from '../Styles';

export const ButtonPlus = ({ disabled, isCard, isGrid, onClick }) => (
  <ButtonTradingStyled
    isGrid={isGrid}
    disabled={disabled}
    isCard={isCard}
    onClick={onClick}
    buy
  >
    <FontAwesomeIcon icon={faPlus} {...(isCard && { style: { height: 21 } })} />
  </ButtonTradingStyled>
);

ButtonPlus.propTypes = {
  disabled: PropTypes.bool,
  isCard: PropTypes.bool,
  isGrid: PropTypes.bool,
  onClick: PropTypes.func,
};
